import React, {useState, useEffect} from "react";
import {createRoot} from 'react-dom/client';
import 'championship/src/fork/ReactModernCalandarDatepicker/DatePicker.css';
import {Calendar, utils as calendar_utils} from 'championship/src/fork/ReactModernCalandarDatepicker';
import AbstractField from "./abstract";
import {russian} from "../../helpers/calendar-location";
// import Inputmask from "inputmask.es6.js";
// import Inputmask from "inputmask";

export function toCalendarFormat(date) {
  if (!date) return
  const parsedDate = date.match(/(\d+)\-(\d+)\-(\d+)/)
  return {
    year: parsedDate[1],
    month: parsedDate[2],
    day: parsedDate[3],
  }
}

const CalendarApp = ({value, callback, max}) => {
  const [selectedDay, setSelectedDay] = useState(null);
  useEffect(() => {
    if (selectedDay) {
      if (callback) {
        callback(selectedDay)
      }
    }
  }, [selectedDay]);
  return (
    <div>
      <Calendar
        value={selectedDay}
        onChange={setSelectedDay}
        shouldHighlightWeekends
        colorPrimary="#FF2424"
        colorPrimaryLight="#FF242433"
        maximumDate={max}
        locale={russian}
      />
    </div>
  );
};

class DateField extends AbstractField {
  __init_dom_schema() {
    return {
      calendar_popup: '.calendar-popup',
      date_input: 'input[type="date"]',
      text_input: 'input[type="text"]',
      wrapper: {
        selector: '.js-form-field__wrapper',
        actions: {
          // 'click|touch': this.toggleCalendar.bind(this),
          'click': this.onToggleCalendar.bind(this),
        }
      },
    }
  }

  __init(node) {
    this.registerEvents('changed')

    const root = createRoot(this.dom.calendar_popup);
    root.render(
      <CalendarApp
        callback={this.applyPickedDate.bind(this)}
        max={toCalendarFormat(this.dom.date_input.getAttribute('max'))}
      />
    );

    this.initDate()

    // Inputmask(
    //     // "datetime",
    //     "99/99/9999",
    //     {
    //         alias: 'datetime',
    //         jitMasking: true,
    //         inputFormat: "dd/MM/yyyy",
    //         outputFormat: "dd/MM/yyyy"
    //         // inputFormat: "dd/MM/yyyy",
    //     }
    // ).mask(this.dom.text_input);
    // Inputmask("99/99/9999",{ "placeholder": "dd/MM/yyyy" }).mask(this.dom.text_input);

  }

  initDate() {
    const date = toCalendarFormat(this.dom.date_input.value)
    if (date) {
      this.applyDate(date)
    }
  }

  applyPickedDate(dateObject) {
    this.applyDate(dateObject);
    this.toggleCalendar()
  }

  applyDate(dateObject) {
    this._applyDate(dateObject)
    this.dispatchEvent('changed')
  }
  _applyDate(dateObject){
    const month = `${dateObject.month}`.padStart(2, '0')
    const day = `${dateObject.day}`.padStart(2, '0')
    this.dom.date_input.value = `${dateObject.year}-${month}-${day}`;
    this.dom.text_input.value = `${day}-${month}-${dateObject.year}`;
  }

  onToggleCalendar(event) {
    this.toggleCalendar()
  }

  toggleCalendar(bool = null) {
    if (bool === null) {
      bool = !this.dom
        .calendar_popup
        .classList
        .contains('is--active');
    }
    this.dom
      .calendar_popup
      .classList
      .toggle('is--active', bool);
    this.node.classList.toggle('is--active', bool)
    if (bool) {
      this.focus()
    }
  }

  isRequired() {
    return this.dom.date_input.hasAttribute('required')
  }

  isFilled() {
    return this.dom.date_input.value !== ''
  }

  getValue(){
    return this.dom.date_input.value
  }

  setValue(value){
    // value = value ?? ''
    let _match
    if(typeof value == 'string' ){
      _match = value.match(/(\d+)\-(\d+)-(\d+)/)
    }
    // console.log(_match)
    if(_match){
      this._applyDate({
        year: _match[1],
        month: _match[2],
        day: _match[3],
      })
    }
  }

  unfocus() {
    this.toggleCalendar(false)
  }
}

export default DateField